<template>
  <div class="tab-content">
    <el-card style="margin-top:10px; text-align: center; color: #999999" v-if="fileShowList.length===0">
      暂无阻抗信息相关文件
    </el-card>
    <el-card style="margin-top:10px; " v-for="(item, index) in fileShowList" :key="index">
      <CardTopBar :title="item.position_keys.impedance.join(',')">
        <template #extra>
          <!-- 解析失败 -->
          <el-tag v-if="item.status_code < 0" type="danger" effect="light">
            解析失败
          </el-tag>
          <!-- 解析完成 -->
          <el-tag v-else-if="item.status_code >= 399" type="success" effect="light">
            解析完成
          </el-tag>
          <!-- 解析中... -->
          <el-tag v-else type="primary" effect="light">
            <span style="display: flex; align-items: center;">
              <el-icon class="is-loading" style="margin-right: 4px;"><Loading /></el-icon>
              <span>解析中...</span>
            </span>
          </el-tag>
        </template>
      </CardTopBar>
      <el-row :gutter="20">
        <el-col :span="13">
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <span style="font-size: 14px; font-weight: bold">{{ item['name'] }}</span>
            <div>
              <el-button size="small" style="border-radius: 40px;" @click="openFile(item['file_path'])">
                打开源文档
              </el-button>
            </div>
          </div>
          <div style="">
            <div style="margin-right: 20px; margin-top: 10px">
              <KVParameterTable :file-info="item" positionKey="impedance"/>
            </div>


            <div style="margin-top: 24px">
              <TableParamTable :file-info="item"  positionKey="impedance"/>
            </div>


            <div style="margin-top: 24px">
              <TextParamTable :file-info="item" positionKey="impedance"/>
            </div>
          </div>
        </el-col>

<!--        <el-col :span="8" class="column-divider">-->
<!--          <div style="margin-top: 35px;">-->
<!--            <div style="font-size: 0.8em;font-weight: bold;">AI解析</div>-->
<!--            <LLMCard :file_info="item"></LLMCard>-->
<!--          </div>-->
<!--        </el-col>-->

        <el-col :span="11" class="column-divider">
          <div style="margin-top: 35px;">
            <div style="font-size: 0.8em;font-weight: bold;">源文档图解</div>
            <el-carousel
                v-if="item['file_image_keys'] && item['file_image_keys'].length > 0"
                :interval="5000"
                arrow="always"
                indicator-position="outside"
                height="400px"
                style="margin-top: 10px">
              <el-carousel-item v-for="(imgSrc, imgIndex) in item['file_image_keys']" :key="imgIndex">
                <el-image
                    :src="imgSrc"
                    fit="contain"
                    style="width: 100%; height: 100%; cursor: pointer;"
                    @click="handlePreview(item, imgIndex)"
                />
              </el-carousel-item>
            </el-carousel>
            <div v-else style="text-align: center; color: #909399; margin-top: 20px;">
              暂无图解
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-image-viewer
        v-if="showImageViewer"
        :url-list="imageViewerList"
        :initial-index="imageViewerIndex"
        @close="closeImageViewer"
        :teleported="true"
    />
  </div>
</template>

<script>
import {ElCol, ElMessage, ElRow, ElImageViewer} from "element-plus";
import CardTopBar from "@/components/params_parse/cardTopBar.vue";
import LLMCard from "@/components/sub_component/llmCard.vue"
import {mapState} from "vuex";

import KVParameterTable from "@/components/sub_component/kvParamTable.vue";
import TextParamTable from "@/components/sub_component/textParamTable.vue";
import TableParamTable from "@/components/sub_component/tableParamTable.vue";
import store from "@/store";
import {Loading} from "@element-plus/icons-vue";

export default {
  components: {
    Loading,
    ElCol,
    ElRow,
    CardTopBar,
    LLMCard,
    ElImageViewer,
    KVParameterTable,
    TextParamTable,
    TableParamTable,
  },
  computed: {
    ...mapState(['commonFileChangeSign', 'statusChangeSign']),
  },
  watch: {
    async commonFileChangeSign(currentSign) {
      if (currentSign > 0) {
        await this.loadShowFiles()
      }
    },
    statusChangeSign(currentSign) {
      if (currentSign > 0) {
        this.loadShowFiles()
      }
    },
  },
  data() {
    return {
      checkItemMap: {},
      keywords: [],
      fileShowList: [],
      historyMode: false,
      showImageViewer: false,
      imageViewerList: [],
      imageViewerIndex: 0,
    };
  },
  methods: {
    openFile(filePath) {
      window.electronAPI.openFile(filePath);
    },
    async loadShowFiles() {
      const allCommonFile = store.state.commonObjList;
      const filteredList = allCommonFile.filter(item => item['select'] && item.position_keys.impedance && item.position_keys.impedance.length >0);
      console.log("loadShowFiles impedance filteredList", filteredList);

      filteredList.forEach(fileInfo => {
        // this.renderFileMatchRes(fileInfo);
      });

      this.fileShowList = filteredList;
      await store.dispatch("fileCheckListLevelChange")
    },

    handlePreview(item, index) {
      this.imageViewerList = item.file_image_keys;
      this.imageViewerIndex = index;
      this.showImageViewer = true;
    },
    closeImageViewer() {
      this.showImageViewer = false;
    }
  },
  mounted() {
    this.checkItemMap = this.$store.state.config?.checkItemMap || {};
    this.loadShowFiles();
  }
};
</script>

<style scoped>
/* ... 样式保持不变 ... */
.column-divider {
  border-left: 1px solid #ebeef5;
}
</style>